module.exports = __webpack_public_path__ + "assets/img/2ca8aa5aa701b481371e36c13775ed37.png";